var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "level" },
          [
            _c(
              "Header",
              _vm._b(
                { staticClass: "level-left" },
                "Header",
                _vm.$route.meta,
                false
              )
            ),
          ],
          1
        ),
        _c("div", { staticClass: "columns" }, [
          _c(
            "div",
            { staticClass: "column" },
            [
              _c(
                "b-field",
                { attrs: { grouped: "" } },
                [
                  _c(
                    "b-field",
                    { attrs: { label: "Fiscal Year" } },
                    [
                      _c("b-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.fiscalYear,
                          callback: function ($$v) {
                            _vm.fiscalYear = $$v
                          },
                          expression: "fiscalYear",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    { attrs: { label: "Inventory Number" } },
                    [
                      _c("b-input", {
                        attrs: { type: "text" },
                        model: {
                          value: _vm.selectedInventory,
                          callback: function ($$v) {
                            _vm.selectedInventory = $$v
                          },
                          expression: "selectedInventory",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-field",
                    [
                      _c(
                        "b-button",
                        {
                          attrs: {
                            type: "is-success",
                            "icon-left": "save",
                            disabled: _vm.isLoading,
                          },
                          on: {
                            click: () => {
                              _vm.resetData()
                              _vm.getData()
                            },
                          },
                        },
                        [_vm._v(" Load ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c("b-field", { attrs: { label: "Plant" } }, [
                _c("div", [_vm._v(" " + _vm._s(_vm.selectedPlant) + " ")]),
              ]),
              _vm._l(_vm.inventories, function (inventory, index) {
                return _c(
                  "b-field",
                  { key: index + "inventory" },
                  [
                    _c(
                      "b-field",
                      {
                        staticClass: "ml-2",
                        staticStyle: {
                          "background-color": "white",
                          "align-items": "center",
                          display: "flex",
                          padding: "0.1rem",
                        },
                      },
                      [
                        _c("div", { staticStyle: { "margin-right": "10px" } }, [
                          _vm._v(" " + _vm._s("Material Name:") + " "),
                        ]),
                        _c("div", { staticStyle: { "margin-right": "10px" } }, [
                          _vm._v(" " + _vm._s(inventory.MatName) + " "),
                        ]),
                      ]
                    ),
                    _c(
                      "b-field",
                      {
                        staticClass: "ml-2",
                        staticStyle: {
                          "background-color": "white",
                          "align-items": "center",
                          display: "flex",
                          padding: "0.1rem",
                        },
                      },
                      [
                        _c("div", { staticStyle: { "margin-right": "10px" } }, [
                          _vm._v(" " + _vm._s("Material N°:") + " "),
                        ]),
                        _c("div", { staticStyle: { "margin-right": "10px" } }, [
                          _vm._v(" " + _vm._s(inventory.Material) + " "),
                        ]),
                      ]
                    ),
                    _c(
                      "b-field",
                      { staticClass: "ml-2" },
                      [
                        _c("b-input", {
                          attrs: {
                            type: "number",
                            disabled: inventory.Counted,
                            min: "0",
                          },
                          model: {
                            value: inventory.qty,
                            callback: function ($$v) {
                              _vm.$set(inventory, "qty", $$v)
                            },
                            expression: "inventory.qty",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      {
                        staticStyle: {
                          height: "100%",
                          "align-items": "center",
                          display: "flex",
                          "margin-left": "0.3rem",
                        },
                      },
                      [
                        _c("div", { staticStyle: { "margin-right": "10px" } }, [
                          _vm._v(" " + _vm._s("Zero?") + " "),
                        ]),
                        _c("b-checkbox", {
                          attrs: {
                            name: "zeroCrates",
                            disabled: inventory.Counted,
                          },
                          model: {
                            value: inventory.zero,
                            callback: function ($$v) {
                              _vm.$set(inventory, "zero", $$v)
                            },
                            expression: "inventory.zero",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _c(
                "b-field",
                [
                  _c(
                    "b-button",
                    {
                      attrs: {
                        type: "is-success",
                        "icon-left": "save",
                        disabled: _vm.isLoading || !_vm.isLoaded,
                      },
                      on: {
                        click: () => {
                          _vm.isValidating = true
                        },
                      },
                    },
                    [_vm._v(" Save ")]
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ]),
        _c(
          "b-modal",
          {
            attrs: {
              active: _vm.isValidating,
              scroll: "keep",
              "has-modal-card": "",
            },
            on: {
              "update:active": function ($event) {
                _vm.isValidating = $event
              },
            },
          },
          [
            _vm.isValidating
              ? _c(
                  "form",
                  {
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.saveInventory.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "modal-card",
                        staticStyle: {
                          "min-width": "50vw",
                          width: "fit-content",
                          height: "fit-content",
                        },
                      },
                      [
                        _c("header", { staticClass: "modal-card-head" }),
                        _c("section", { staticClass: "modal-card-body" }, [
                          _vm._v(
                            " Are you sure? Submitted inventories cannot be modified. "
                          ),
                        ]),
                        _c("footer", { staticClass: "modal-card-foot" }, [
                          _c(
                            "button",
                            {
                              staticClass: "button is-info is-fullwidth",
                              attrs: { type: "submit" },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$t("global.submit")) + " "
                              ),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]
                )
              : _vm._e(),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }